
const apiUrl = process.env.REACT_APP_BACKEND_EVENT;

export const loginUser = async (username, password) => {
    try {
        return await fetch(`${apiUrl}/auth/login`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({username, password}),
        });

    } catch (error) {
        throw error;
    }
};

export const signInWithToken = async (token) => {
    try {
        return await fetch(`${apiUrl}/auth/token`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        });

    } catch (error) {
        throw error;
    }
};


